import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, DropdownMenu, DropdownMenuItem, Typography } from 'seagull';
import { ChevronDown, ChevronUp, DocumentCheckmark, EditAI, EmailSent, Import, Trash } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import styles from './DraftsDashboard.module.scss';
export const GetBulkActionsTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            BulkActionsTID: {
                Counter: 'drafts-dashboard-bulk-counter',
                Trigger: 'drafts-dashboard-bulk-actions',
                Send: 'drafts-dashboard-bulk-send',
                ExternallySign: 'drafts-dashboard-bulk-externally-sign',
                EditWithAI: 'drafts-dashboard-bulk-edit-with-ai',
                Export: 'drafts-dashboard-bulk-export',
                Remove: 'drafts-dashboard-bulk-remove'
            }
        }
    });
const BulkActions = (param)=>{
    let { numSelected, setBulkActionsOpen, bulkActionsOpen, bulkSend, bulkExternallySign, bulkDiscard, bulkExport, bulkExportDisabled, onEditWithAI } = param;
    const { t: draftsTexts } = useLocaleKeys('pages.draftsDashboard');
    const { BulkActionsTID } = useMemo(()=>GetBulkActionsTID(), []);
    const { BULK_AGENTIC_DRAFTS } = useFeatureFlags();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            numSelected > 0 && /*#__PURE__*/ _jsx(Typography, {
                testId: BulkActionsTID.Counter(),
                children: draftsTexts.draftsSelected({
                    count: numSelected
                })
            }),
            /*#__PURE__*/ _jsx(DropdownMenu, {
                onOpenChange: setBulkActionsOpen,
                target: /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'open_drafts_bulk_actions'
                    },
                    testId: BulkActionsTID.Trigger(),
                    skin: "primaryOutline",
                    suffixIcon: bulkActionsOpen ? /*#__PURE__*/ _jsx(ChevronUp, {}) : /*#__PURE__*/ _jsx(ChevronDown, {}),
                    disabled: numSelected === 0,
                    children: draftsTexts.bulkActions()
                }),
                children: [
                    {
                        icon: /*#__PURE__*/ _jsx(EmailSent, {
                            size: 20
                        }),
                        testId: BulkActionsTID.Send(),
                        text: draftsTexts.bulkSendProposals(),
                        onClick: bulkSend
                    },
                    {
                        icon: /*#__PURE__*/ _jsx(DocumentCheckmark, {
                            size: 20
                        }),
                        testId: BulkActionsTID.ExternallySign(),
                        text: draftsTexts.bulkApproveOnBehalf(),
                        onClick: bulkExternallySign
                    },
                    ...BULK_AGENTIC_DRAFTS ? [
                        {
                            icon: /*#__PURE__*/ _jsx(EditAI, {
                                size: 20
                            }),
                            testId: BulkActionsTID.EditWithAI(),
                            text: draftsTexts.bulkEditWithAI(),
                            onClick: onEditWithAI
                        }
                    ] : [],
                    {
                        icon: /*#__PURE__*/ _jsx(Import, {
                            size: 20
                        }),
                        testId: BulkActionsTID.Export(),
                        text: draftsTexts.bulkExport(),
                        intent: Intent.ExportDraftsToCsv,
                        onClick: bulkExport,
                        disabled: bulkExportDisabled
                    },
                    {
                        icon: /*#__PURE__*/ _jsx(Trash, {
                            size: 20
                        }),
                        testId: BulkActionsTID.Remove(),
                        text: draftsTexts.bulkDiscardDrafts(),
                        intent: Intent.DiscardDraft,
                        skin: 'error',
                        onClick: bulkDiscard
                    }
                ].map((param)=>{
                    let { icon, testId, text, intent, skin, onClick, disabled } = param;
                    return /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        bi: {
                            name: 'drafts_bulk_action'
                        },
                        iconStart: /*#__PURE__*/ _jsx("div", {
                            className: styles.bulkActionIcon,
                            children: icon
                        }),
                        testId: testId,
                        intent: intent,
                        skin: skin,
                        onClick: onClick,
                        disabled: disabled,
                        children: text
                    }, testId);
                })
            })
        ]
    });
};
export default BulkActions;
